import RoomInstance from "../RoomInstance";
import CONQUER from "../../../CONQUER";
import { STATUS, ACTIONS } from "../../../../Models/ENUM";
import Entries from "../Entries";
import LOG, { log } from "../../../../UTIL/LOG";
import ARRAY from "../../../../UTIL/ARRAY";
import RoomPlayerStatus from "./RoomPlayerStatus";
import RoomPlayerState from "./RoomPlayerState";

class RoomPlayerInstance
{
    public Room        : RoomInstance;
 
    public data         : any = {};
    public gameKey      : any;
    public isBot        : boolean = true;
    public isNPC        : boolean = false;
    public isME         : boolean = false;
    public Status       : RoomPlayerStatus;
    public State        : RoomPlayerState;
    public avatarID     : any;
    public snappy       : any;
    public fullName    : any;
    public userPhoto    : any;

    private syncCallback : any;
 
    constructor( Room:RoomInstance, data:any )
    {
        this.Room       = Room;

        this.Status     = new RoomPlayerStatus( this );
        this.State      = new RoomPlayerState( this );

        this.data       = data;
        this.avatarID   = data.avatarID;
        this.isBot      = data.isBot;
        this.isME       = this.avatarID == Room.conquer.User.avatarID;

        this.snappy     = data.snappy;
        this.fullName   = data.fullName;
        this.userPhoto  = data.userPhoto;
    }
 
    public leave()
    {
        this.Room.leave();
    };

    public chat( text:any )
    {
        this.Room.chat( text );
    }

    public entry( text:any )
    {
        this.Room.chat( text );
    }

    public send( data:any )
    {
        this.Room.doSend( ACTIONS.PLAYERVARS, data );
    }

    public sync( callback?:Function )
    {
        this.syncCallback = callback;
        this.Room.doSend( ACTIONS.SYNCREQUEST );
    }

    public onServerSynced()
    {
        if( this.syncCallback ) this.syncCallback();
        this.syncCallback = null;
    }

    public update( data:any )
    {
        ARRAY.extract( data, this.data );
        // fire or something
    }
 
    /*
    loadPublic
    resetMultiplier
    resetPermanentMultiplier
    setAnimation
    setCoins
    setInventory
    setPermanentMultiplier
    setScore
    showPosition
    syncRequest
    updatePosition
    hidePosition
    increaseCoins
    increaseMultiplier
    increaseScore
    */
 
}

export default RoomPlayerInstance;